import React, { useEffect } from 'react';
import classnames from 'classnames';
import propTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core';

import styles from '../../../HoursBlock/styles';
import DayInput from 'components/DayInput';
import TimeInput from 'components/TimeInput';
import { useTimeSettingsFormat } from 'common/useTimeSettingsFormat';
import { convertTimeObject } from 'common/dateFormatConfig';
import { getEffectiveStartTime } from 'helpers/helpers';
import { differenceInDays } from 'date-fns';

const StartTimeBlock = ({
  classes,
  sheet,
  data,
  updateStartTime,
  setStartTime,
  canEdit,
  noPadding,
  errorData,
}) => {
  const getTimeFormatHook = useTimeSettingsFormat();
  const is12Format = getTimeFormatHook().is12Format;

  // A host that seeds `data` itself passes no `setStartTime`.
  useEffect(() => {
    if (!data && setStartTime) {
      const {
        hour: hourStart,
        minute: minuteStart,
        amPm: amPmStart,
      } = convertTimeObject(getEffectiveStartTime(sheet.startTime, sheet.startTimeDate), is12Format);
      const dayStart = sheet.startTimeDate ? `${differenceInDays(new Date(sheet.startTimeDate), new Date(sheet.createdAt))}` : '0';
      const startTime = { dayStart, hourStart: String(Number(hourStart)), minuteStart, amPmStart };
      setStartTime(startTime);
    }
  }, [data]);

  if (!data) return null;
  return (
    <div className={classnames(classes.inlineFlex, classes.rowWrapper, classes.startTimeWrapper)}>
      <Typography
        variant="body1"
        color="textSecondary"
        className={classnames(classes.regularFontWeight, classes.paddingBottom)}
      >
        Start time:
      </Typography>
      <div className={classnames(classes.fields, !noPadding && classes.gutter)}>
        <DayInput
          value={data.dayStart}
          onChange={(dayStart) => updateStartTime({ dayStart })}
          baseDate={sheet.createdAt}
          error={Boolean(errorData)}
          disabled={!canEdit}
        />
        <TimeInput
          value={{ hour: data.hourStart, minute: data.minuteStart, amPm: data.amPmStart }}
          onChange={({ hour, minute, amPm }) =>
            updateStartTime({ hourStart: hour, minuteStart: minute, amPmStart: amPm })
          }
          error={Boolean(errorData?.startTimeError)}
          disabled={!canEdit}
        />
      </div>
    </div>
  );
};

StartTimeBlock.propTypes = {
  classes: propTypes.object.isRequired,
  sheet: propTypes.object.isRequired,
  updateStartTime: propTypes.func.isRequired,
};

export default withStyles(styles)(StartTimeBlock);
